export class InvalidUserPoolProviderName extends Error {
  constructor(message = 'User pool provider name not specified or not a string.') {
    super(message);
  }
}
